import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createVNode as _createVNode, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = {
  key: 0,
  class: "operator-name"
}
const _hoisted_3 = {
  key: 1,
  class: "reply-to-message"
}
const _hoisted_4 = {
  key: 0,
  class: "reply-sender"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 2,
  class: "reply-attachments"
}
const _hoisted_7 = {
  key: 2,
  class: "d-block text"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = { key: 4 }
const _hoisted_10 = { key: 5 }
const _hoisted_11 = { class: "text-truncate" }
const _hoisted_12 = ["href"]
const _hoisted_13 = { key: 6 }

import Htmlify from "~/chat/vue/misc/ChatHtmlify.vue";
import {IMessageAttachment} from "~/chat/ts/data/chat/IMessage";
import StringHelper from "~/ts/library/StringHelper";
import {__} from "~/ts/library/Translate";
import {useMessageTypeProps} from "~/chat/vue/widget/tabs/chat/useMessageType";
import {computed, ref} from "vue";
import {ConfigStore} from "~/chat/ts/store/Config";
import ChatMessageFileContent from "~/chat/vue/widget/tabs/chat/ChatMessageFileContent.vue";


const __default__ = {
    name: "ChatMessageTypeText"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    ...useMessageTypeProps(),
    margin: {
        type: Boolean,
        default: true
    },
    showDateIfNeeded: {
        type: Boolean,
        default: true
    }
},
  emits: ["height-increase"],
  setup(__props, { emit: __emit }) {

let props = __props;

let emits = __emit;

let sticker = ref<HTMLImageElement>();

let imageOnly = ref(false);

let isImageOnly = computed(() => {
    return (imageOnly.value && !props.message.attachments.length) || (!text.value && props.message.attachments.length == 1 && props.message.attachments[0].type == "image");
});

let text = computed(() => {
    return props.message.textForDisplay;
});

let isBlockMessage = computed(() => {
    return props.message.isBlockMessage;
});

let isHtmlMessage = computed(() => {
    return props.message.isHtmlMessage;
});

let isShowName = computed(() => {
    let message = props.message;
    return ConfigStore.design.value.dialog.history.displayOperatorName && !message.isBlockMessage && !message.isHideOperator && !message.isFromClient && message.isFirstMessageOf && message.operator && message.operator.fio;
});

function getAttachHtml(attach: IMessageAttachment): string {
    let name = StringHelper.htmlEntities(attach.fileName);
    let url = attach.url
        .split("//download.me-talk.ru/")
        .join("//download.site-chat.me/");
    return `<a href="${url}" target="_blank">${name}</a>`;
}

let replySender = computed(() => {
    if (props.message.replyToMessage) {
        if (props.message.replyToMessage.isFromClient) {
            return __("YOU");
        } else {
            let operator = props.message.replyToMessage.operator;
            if (operator) {
                return operator.fio;
            } else {
                return __("OPERATOR");
            }
        }
    }
    return null;
});

let replyAttachmentsDescr = computed(() => {
    if (props.message.replyToMessage) {
        let attachments = props.message.replyToMessage.attachments.length;
        if (attachments) {
            return `${__("FILES")}: ${attachments}`;
        }
    }
    return null;
});

function onStickerLoad() {
    emits("height-increase", sticker.value.offsetHeight);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
            'text-message-wrapper',
            _ctx.message.isFromClient ? 'client' : 'operator',
            __props.margin ? 'margin' : undefined,
        ])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([
                'text-message message-border-radius typo',
                _ctx.message.isFromClient ? 'client' : 'operator',
                _unref(isImageOnly) ? 'only-image' : null,
                _unref(isShowName) ? 'is-show-name' : null,
                _ctx.message.isHtmlMessage ? 'is-html' : 'is-plain-text',
                _unref(isBlockMessage) || _unref(isImageOnly) ? 'block' : (_ctx.message.isFromClient ? 'client-message-background' : (_ctx.message.rawMessage.isBotMessage ? 'bot-message-background' : 'operator-message-background')) + ' default'
            ]),
      title: __props.showDateIfNeeded ? _ctx.message.dt.toLocaleDateTimeString() : null
    }, [
      (_unref(isShowName))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.message.operator.fio), 1))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "reply-button"),
      (_ctx.message.replyToMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_unref(replySender))
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(replySender)), 1))
              : _createCommentVNode("", true),
            (_ctx.message.replyToMessage.text)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(Htmlify, {
                    value: _ctx.message.replyToMessage.text,
                    emoji: !_ctx.message.replyToMessage.isHtmlMessage,
                    links: !_ctx.message.replyToMessage.isHtmlMessage,
                    escape: !_ctx.message.replyToMessage.isHtmlMessage,
                    snippet: !_ctx.message.replyToMessage.isHtmlMessage,
                    bbcode: !_ctx.message.replyToMessage.isFromClient && !_ctx.message.replyToMessage.isHtmlMessage,
                    onHeightIncrease: _cache[0] || (_cache[0] = ($event: any) => (_unref(emits)('height-increase', $event)))
                  }, null, 8, ["value", "emoji", "links", "escape", "snippet", "bbcode"])
                ]))
              : _createCommentVNode("", true),
            (_unref(replyAttachmentsDescr))
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(replyAttachmentsDescr)), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_unref(text))
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(Htmlify, {
              value: _unref(text),
              emoji: !_unref(isHtmlMessage),
              links: !_unref(isHtmlMessage),
              escape: !_unref(isHtmlMessage),
              snippet: !_unref(isHtmlMessage),
              bbcode: !_ctx.message.isFromClient && !_unref(isHtmlMessage),
              "image-only": _unref(imageOnly),
              "onUpdate:imageOnly": _cache[1] || (_cache[1] = ($event: any) => (_isRef(imageOnly) ? (imageOnly).value = $event : imageOnly = $event)),
              onHeightIncrease: _cache[2] || (_cache[2] = ($event: any) => (_unref(emits)('height-increase', $event)))
            }, null, 8, ["value", "emoji", "links", "escape", "snippet", "bbcode", "image-only"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.message.stickerUrl)
        ? (_openBlock(), _createElementBlock("img", {
            key: 3,
            ref_key: "sticker",
            ref: sticker,
            class: "sticker",
            src: _ctx.message.stickerUrl,
            onLoad: onStickerLoad
          }, null, 40, _hoisted_8))
        : _createCommentVNode("", true),
      (_ctx.message.attachments.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.message.attachments, (attach) => {
              return (_openBlock(), _createBlock(ChatMessageFileContent, {
                attachment: attach,
                onHeightIncrease: _cache[3] || (_cache[3] = ($event: any) => (_unref(emits)('height-increase', $event)))
              }, null, 8, ["attachment"]))
            }), 256))
          ]))
        : _createCommentVNode("", true),
      (_ctx.message.knowledgeBaseArticles)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.message.rawMessage.knowledgeBaseArticles, (article) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("a", {
                  href: article.url ? article.url : 'about:blank',
                  target: "_blank"
                }, _toDisplayString(article.descr), 9, _hoisted_12)
              ]))
            }), 256))
          ]))
        : _createCommentVNode("", true),
      (_ctx.$slots.reactions)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _renderSlot(_ctx.$slots, "reactions")
          ]))
        : _createCommentVNode("", true)
    ], 10, _hoisted_1)
  ], 2))
}
}

})